/* @flow */

import { PageType } from "../types/PageType";

export const ReplacementKindSearch = "search";
export const ReplacementKindDana = "dana";
export type ReplacementKind = typeof ReplacementKindSearch | typeof ReplacementKindDana | "NONE";

export type TrackingTags = {
    eventId?: string | null;
    originEventId?: string | null;
    eventCategory?: string | null;
    eventAction?: string | null;
    eventLabel?: string | null;
    eventGroupId?: string | null;
    bettyBundleId?: string | null;
    description?: string | null;
    brandName?: string | null;
    name?: string | null;
    categoryIds?: string | null;
    groupName?: string | null;
    mainGroupName?: string | null;
    subGroupName?: string | null;
    contextId?: string | null;
    searchViewId?: string | null;
    position?: string | null;
    origin?: string | null;
    pageType?: string;
    zeroResultType?: string | null;
    page?: string;
    type?: string; // is the itemType in basket tracking (Search Result),
    favorite?: boolean | null;
    onList?: boolean | null;
    recentlyOrdered?: boolean | null;
    inContainer?: boolean | null; // related to type but obtained in a very different way,
    customerIndividualPrice?: boolean | null;
    basePrice?: string | null;
    deliveryPrice?: string | null;
    promo?: boolean | null;
    image?: boolean | null;
    remote_vertical?: string | null;
    remote_service?: string | null;
    urltemplate?: string | null;
    categoryId?: string | null;
    categoryName?: string | null;
    pageName?: string | null;
    availability?: string | null;
    listId?: string | null;
    orderId?: string | null;
    listType?: string | null;
    query?: string | null;
    key?: string | null;
    category?: string | null;
    selected?: boolean | null;
    regularResults?: number | null;
    usedOrSearch?: boolean | null;
    menuSource?: string;
    menuTarget?: string;
    minValue?: number | null;
    maxValue?: number | null;
    pageNumber?: number | null;
    brokenItems?: number | null;
    visible?: boolean | null;
    title?: string | null;
    url?: string | null;
    method?: string | null;
    suggestionIndex?: number | null;
    indexWithinGroup?: number | null;
    originalQuery?: string | null;
    autoCorrectedSolrQuery?: string | null;
    sourceRouterPath?: string | null;
    sourceRouterQuery?: string | null;
    sourcePath?: string | null;
    sourceHost?: string | null;
    sourceQuery?: string | null;
    layout?: string | null;
    displayUnit?: string | null;
    suggestions?: string | null;
    articleSuggestions?: string | null;
    numSuggestions?: number | null;
    numArticleSuggestions?: number | null;
    numSearchSuggestions?: number | null;
    numCategorySuggestions?: number | null;
    globallyVisible?: boolean | null;
    customerVisible?: boolean | null;
    withPrices?: boolean | null;
    toggleState?: boolean | null;
    sort?: string | null;
    fsd?: boolean | null;
    storeids?: string | null;
    unchecked?: boolean | null;
    carrier?: string | null;
    to?: string | null;
    from?: string | null;
    selectedSortCriteria?: string | null;
    storeName?: string | null;
    storeId?: string | null;
    initialSearch?: boolean | null;
    typeOfFacet?: string;
    shopId?: string;
    tab?: "searchTab" | "contentTab";
    hasDescription?: boolean;
    hasImage?: boolean;
    marketplace?: boolean;
    offerId?: string | null;
    trackingId?: string | null;
    shownEvaluations?: number;
    totalEvaluations?: number | null;
    articlePrice?: number;
    currency?: string | null;
    totalValue?: number;
    articleIds?: string[];
    nrOfLists?: number | null;
    nrItems?: number | null;
    variantName?: string | null;
    categoryPath?: string | null;
    subsysNumber?: string | null;
    mgbNumber?: string | null;
    listPosition?: number | null; // Index of the item in a list
    solrScore?: number | null;
    listIndex?: number | null; // Index of list in the list overview.
    recentlyBoughtDisplayed?: boolean | null;
    cipDisplayed?: boolean | null;
    isRecentlyBoughtList?: boolean | null;
    isCipList?: boolean | null;
    readOnlyForEmployees?: boolean | null;
    newItemId?: string;
    oldItemId?: string;
    replacementLinkShown?: boolean;
    invoiceLinkRendered?: boolean;
    ownBrand?: string | null | undefined;
    replacementKind?: ReplacementKind;
    missingArticleIds?: string[] | null | undefined;
    marketplaceOrderId?: string;
    nrOfFiles?: number;
    newThread?: boolean;
    tierLevel?: string;
    status?: string;
    solrResultIds?: string[];
    ropoRank?: number | null;
    bundleListExpanded?: boolean;
    originalBettyVariantBundleId?: string | null;
    bettyVariantId?: string;
    bettyVariantBundleIds?: string[];
    showsSummaryDnrInfo?: boolean | null | undefined;
    isLoggedIn?: boolean | null | undefined;
    isEmployee?: boolean | null | undefined;
} & { [key: string]: any };

export type StructuredTrackingData = {
    tags?: TrackingTags | null;
    metric?: number | null;
};

export type CompulsoryTrackingTags = {
    originEventId: string;
    pageType: PageType;
};
